import { AppLogoType } from '@thoughtspot/custom-style-service';
import { Image } from '@thoughtspot/radiant-react/widgets/image';
import cx from 'classnames';
import React from 'react';
import { useBlinkContextForSparkflow } from "../../../../contexts/sparkflow-blink-context";
import { THOUGHTSPOT_LOGO_SRC } from "../../../../utils/sparkflow-constants";
import styles from './app-logo.container.module.scss';
export const AppLogo = ({ className }) => {
    const { customStylingService, sessionService, } = useBlinkContextForSparkflow();
    const logo = customStylingService
        ?.getConfig()
        ?.getAppLogoUrl(AppLogoType.DEFAULT, THOUGHTSPOT_LOGO_SRC) ??
        THOUGHTSPOT_LOGO_SRC;
    const altText = sessionService?.getProductName?.() ?? 'ThoughtSpot';
    return (React.createElement(Image, { className: cx(styles.logo, className), src: logo, fallbackSrc: THOUGHTSPOT_LOGO_SRC, alt: altText }));
};
//# sourceMappingURL=app-logo.container.js.map